import { endpoint } from "./endpoint";
// import Papa from "papaparse";

const Axios = require("axios");

export async function getLineData(variant) {
  return process.env.NODE_ENV === "production"
    ? Axios.get(endpoint.concat(`weekRegion2perc_${variant}.json`))
        .then((result) => {
          return result.data;
        })
        .catch((err) => {
          console.log("err :>> ", err);
          return [];
        })
    : new Promise((res, rej) => {
        setTimeout(() => {
          const LineData = require(`../assets/data/weekRegion2perc_${variant}.json`);
          res(LineData);
        }, 3500);
      });
  // return process.env.NODE_ENV === "production"
  //   ? Axios.get(endpoint.concat("ukvui_weekRegion2perc.tsv"))
  //       .then((result) => {
  //         const parsed = Papa.parse(result.data, {
  //           delimiter: "\t",
  //           dynamicTyping: true,
  //           skipEmptyLines: true,
  //         });
  //         console.log("parsed :>> ", parsed);
  //         return parsed.data;
  //       })
  //       .catch((err) => {
  //         console.log("err :>> ", err);
  //         return [];
  //       })
  //   : Axios.get(LineData)
  //       .then((result) => {
  //         const parsed = Papa.parse(result.data, {
  //           delimiter: "\t",
  //           dynamicTyping: true,
  //           skipEmptyLines: true,
  //         });
  //         return parsed.data;
  //       })
  //       .catch((err) => {
  //         console.log("err :>> ", err);
  //         return [];
  //       });
}
